import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import aboutImg1 from '../assets/images/about-img1.jpg';
import aboutImg2 from '../assets/images/about-img2.jpg';

const AboutSection = () => {
    const { t } = useTranslation();
    return (
        <section className="float-left w-100 about-us-con position-relative padding-top padding-bottom main-box">
            <Container>
                <Row className="align-items-center">
                    <Col lg={6} md={6} className="wow animate__animated animate__fadeInLeft" data-wow-duration="2s" data-wow-delay="0.2s">
                        <div className="about-us-img-con d-flex">
                            <figure><img src={aboutImg1} alt="About us 1" className="img-fluid" /></figure>
                            <figure className="abt-img2"><img src={aboutImg2} alt="About us 2" className="img-fluid" /></figure>
                        </div>
                    </Col>
                    <Col lg={6} md={6} className="wow animate__animated animate__fadeInRight" data-wow-duration="2s" data-wow-delay="0.2s">
                        <div className="about-us-content-con">
                            <div className="heading-title-con mb-0">
                                <span className="special-text color-blue d-block">{t('about_us_tag')}</span>
                                <h2 dangerouslySetInnerHTML={{ __html: t('about_us_title') }}></h2>
                                <p>{t('about_us_desc1')}</p>
                                <p className="prgrph-2">{t('about_us_desc2')}</p>
                                <ul className="list-unstyled p-0">
                                    <li className="position-relative"><FontAwesomeIcon icon={faCheck} /> {t('about_us_point1')}</li>
                                    <li className="position-relative mb-0"><FontAwesomeIcon icon={faCheck} /> {t('about_us_point2')}</li>
                                </ul>
                                <a href="/about" className="text-decoration-none primary_btn d-inline-block">{t('banner_get_started')}</a>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default AboutSection;